import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FlatButton, TextField } from 'material-ui'
import styles from './link-styles'

class SocialLink extends Component {
  constructor(props) {
    super(props)
    this.state = {
      linkState: this.props.link || '',
    }
  }

  componentWillReceiveProps(nextProps) {
    const { link: nextLink } = nextProps
    const { linkState } = this.state
    if (nextLink !== linkState) {
      this.setState({ linkState: nextLink })
    }
  }

  updateLinkState = linkState => {
    this.setState({ linkState })
  }

  render() {
    const { link, type, updateLink } = this.props
    const { linkState } = this.state
    const submitDisabled = linkState === link
    return (
      <div style={styles.link}>
        <img style={styles.icon} src={`/images/${type}.svg`} alt={type} />
        <TextField
          fullWidth
          value={linkState || ''}
          name={`${type}Url`}
          onChange={e => this.updateLinkState(e.target.value)}
        />
        <FlatButton
          label="Update"
          primary
          onClick={() => updateLink(type, linkState)}
          disabled={submitDisabled}
        />
      </div>
    )
  }
}

SocialLink.propTypes = {
  link: PropTypes.string,
  type: PropTypes.string.isRequired,
  updateLink: PropTypes.func.isRequired,
}

export default SocialLink



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/SocialLink.js